<template>

  <div ref="akkordeon-item" class="akkordeon-item" v-if="item.titel" data-open="false">
    <div ref="akkordeonheader" class="akkordeon-header" @click="open=!open">
      <img style="width: 25px;" v-if="!open" src="../assets/EKSElement-more.svg" />
      <img style="width: 15px" v-if="open" src="../assets/EKSElement-more-active.svg" /><span class="trenner"></span>
      <div v-html="item.titel"></div>
    </div>
    <transition name="fade">
      <div ref="akkordeoncontent" class="akkordeon-content" v-html="item.content" v-if="open"></div>
    </transition>
  </div>

</template>

<script>
export default {
  name: 'AkkordeonItem',
  data() {
    return {
      open: false
    }
  },
  props: {
    item: null
  },
}
</script>



<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.akkordeon-item {
  margin-bottom: 20px;
}
.akkordeon-header {
  background-color: #c1b08c;
  padding: 10px 30px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
}
.akkordeon-header span.trenner {
  color: white;
  margin-left: 5px;
  margin-right: 5px;
  border-left: 1px solid white;
  box-sizing: border-box;
}
.akkordeon-header div {
  color: #350f37;
  font-weight: 700;
  margin-bottom: 0;
  padding-bottom: 0;
}
.akkordeon-content {
  background-color: #c1b08c;
  padding: 10px 30px 30px 30px;
  box-sizing: border-box;
  font-weight: 600;

  ::v-deep h2 {
    font-weight: 700;
  }
}
.akkordeon-content p {
  color: white !important;
}

</style>
